import { apiStatus } from '@va/constants';
import {
  WixPermissionPack,
  WixPlanCycle,
  WixPlanIndexes,
  wixPermissionPackPlanIndexes,
} from '@va/wix/shared/constants';

export const getApiRequestStatus = (state: any, apiRequestName: string) =>
  state.getIn(['api', apiRequestName, 'status'], apiStatus.NONE);

export const getPermissionPackage = (state: any) =>
  state.getIn(
    ['core', 'api', 'getFeaturePermissions', 'wixPermissionPack'],
    WixPermissionPack.FREE,
  ) as WixPermissionPack;

/** The active plan's position in the plans' price order, to be compared against {@link WixPlanIndexes}. */
export const getWixPlanIndex = (state: any) =>
  wixPermissionPackPlanIndexes[getPermissionPackage(state)] ?? WixPlanIndexes.FREE;

export const getWixPlanCycle = (state: any) =>
  state.getIn(['core', 'api', 'getFeaturePermissions', 'wixCycleType'], WixPlanCycle.UNKNOWN) as WixPlanCycle;
